/**
 * frontend/src/pages/valuation/_valuationSession.ts
 *
 * Leaf module — zero imports of its own, deliberately. `AuthContext.tsx`
 * (imported by every product's shell, not just Valuation) needs
 * `clearValuationSession()` at sign-out. `_shared.tsx` needs the prefix to
 * build its own cache keys. If either the sweep or the prefix lived in
 * `_shared.tsx`, that file's `useAuth` import (from AuthContext) would close
 * a cycle: AuthContext -> _shared -> AuthContext. `_shared.tsx` also pulls in
 * react-router-dom and ui/badge for unrelated UI helpers, which a cycle would
 * drag into every product's bundle just for this string sweep.
 *
 * VAL-SESSION-HYGIENE-1 (R1, corrected — this file, not _shared.tsx, is the
 * sweep's home; see FIX 1 in the follow-up session).
 */

export const VALUATION_KEY_PREFIX = 'valuation:'

/**
 * Removes every sessionStorage key namespaced under VALUATION_KEY_PREFIX
 * (run cache, tuning-input cache, and anything future work adds under the
 * same prefix). Called on sign-out so the next person to sign in on this
 * machine cannot open an in-progress engagement and see the previous user's
 * cached run or methodology inputs with the sign-off gate still green.
 *
 * Wrapped in try/catch: sessionStorage can throw in private-mode Safari or
 * when a quota is exceeded, and a failed sweep must never block sign-out.
 */
export function clearValuationSession(): void {
  try {
    const toRemove: string[] = []
    for (let i = 0; i < sessionStorage.length; i++) {
      const key = sessionStorage.key(i)
      if (key && key.startsWith(VALUATION_KEY_PREFIX)) toRemove.push(key)
    }
    toRemove.forEach(key => sessionStorage.removeItem(key))
  } catch {
    /* best effort — see docstring */
  }
}
